module.exports = __webpack_public_path__ + "media/images/cross-15-1218e1ac.svg";